import React from 'react';
import { View, StyleSheet } from 'react-native';
import Text from 'design-system/Text';
import { rem, Spacer } from 'design-system';
const BarInfo = ({ color, title, metrics }) => (<View style={styles.container}>
    <View style={[styles.colorView, { backgroundColor: color }]}/>
    <Spacer w={16}/>
    <View style={styles.flex1}>
      <Text TextThin-14 Secondary numberOfLines={1}>
        {title}
      </Text>
      <Text Numbers-16 numberOfLines={1}>
        {metrics}
      </Text>
    </View>
  </View>);
export default BarInfo;
const styles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: 'center',
        flexDirection: 'row',
    },
    colorView: {
        width: rem(8),
        height: rem(8),
        borderRadius: rem(8),
    },
    flex1: {
        flex: 1,
    },
});
